import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import SummaryComp from '../../../components/patientApp/patientChat/summary/summary'

const Summary = () => {
    return <Background>
        <SummaryComp />
    </Background>
}
export default Summary;